module.exports = __webpack_public_path__ + "img/no1.fe570fdd.png";